<div class="container-fluid p-0">
  <!-- Header with controls: add, etc -->
  <div class="header">
    <div class="row m-0">
      <div class="col pl-0 pr-0" *ngIf="!hideAddButton">
        <button type="button" class="btn btn-sm pl-0 ml-0" [routerLink]="'./'" (click)="onAdd()">
          <span class="mr-2">NEW STORYBOARD</span>
          <span><i class="icon icon-btn-create-cover" aria-hidden="true"></i></span>
        </button>
      </div>
    </div>
    <div class="row m-0">
      <div class="col col-6 pl-0 pr-0">
        <button type="button" class="btn btn-sm pl-0 ml-0 sort sort-storyboard" [class.selected]="sort == SortName.Filename" (click)="onColumnSort(SortName.Filename)">
          <span>STORYBOARD NAME</span>
          <span class="ml-1"><i class="icon icon-arrow-back-breadcrumb" [class.desc]="direction === Direction.Descending" aria-hidden="true"></i></span>
        </button>
      </div>
      <div class="col col-2 pr-0">
      <!--  <button type="button" class="btn btn-sm pl-0 ml-0 sort sort-author" [class.selected]="sort == SortName.Author" (click)="onColumnSort(SortName.Author)">-->
      <span class="sort sort-author">AUTHOR</span>
         <!-- <span class="ml-1"><i class="icon icon-arrow-back-breadcrumb" [class.desc]="direction === Direction.Descending" aria-hidden="true"></i></span>-->
       <!-- </button>-->
      </div>
      <div class="col col-2 pl-0 pr-0">
        <button type="button" class="btn btn-sm pl-0 ml-0 sort sort-date" [class.selected]="sort== SortName.Date" (click)="onColumnSort(SortName.Date)">
          <span>CREATED</span>
          <span class="ml-1"><i class="icon icon-arrow-back-breadcrumb" [class.desc]="direction === Direction.Descending" aria-hidden="true"></i></span>
        </button>
      </div>
    </div>
  </div>

  <!-- Storyboard list -->
  <div class="storyboard-list">
    <div class="storyboard-list-item mb-1" *ngFor="let storyboard of assets">
      <app-asset-data-table [data]="storyboard" [source]="'STORYBOARD'" [showRowNumber]="true"
        [allowItemOrder]="true" [allowEdit]="!hideModifyButton"  [allowDelete]="!hideModifyButton"
        [showView]="true" [showContent]="isContentShow(storyboard.id)" [allowDrop]="!disableDrop"
        (open)="onContentState(storyboard, $event)" (edit)="onEdit($event)" (delete)="onDelete($event)"
        (save)="onSave($event)" (view)="onView(storyboard)"></app-asset-data-table>
      </div>
  </div>

  <button type="button" *ngIf="!!lastEvaluatedKey" class="btn btn-link link-arrow more-results float-right text-right text-uppercase pr-0 mr-0" (click)="getNext()">
    More results<i class="icon icon-arrow-fwd-sm-link"></i>
  </button>
</div>
